// ----------------------------------------------------------------------------
// Helper: Store Geolocation
// Hides the "Find In Store" section in the PDP if user's location is more than 50km
// ----------------------------------------------------------------------------

// -------------------------------------
// Class Constants
// -------------------------------------
const FIND_IN_STORE_ACCORDION   = ".accordion--find-in-store";
const STORE_TAB                = ".tab__content--store";

// -------------------------------------
// Functions Helpers
// -------------------------------------
const checkStoreProximity = () => {
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(crossLocations, blockLocationPromt);
    } 
};

const crossLocations = (position) => {
    const storeTabs = document.querySelectorAll(STORE_TAB);
    
    if (storeTabs.length < 1) return false;
    
    const userCoordinates = {
        latitude: position.coords.latitude,
        longitude: position.coords.longitude
    }
    
    const storeLocations = [...storeTabs].reduce((validCoordinates, store) => {
        const coordinates = store.dataset.coordinates;
        
        if (coordinates !== null && coordinates !== "") {
            validCoordinates.push(coordinates);
        }
        
        return validCoordinates 
    }, []);
    
    
    let storeCloseBy = false;
    
    storeLocations.forEach((location) => {
        const storeCoordinates = location.split(',');
        
        const storelatitude = parseFloat(storeCoordinates[0].trim());
        const storelongitude = parseFloat(storeCoordinates[1].trim());

        const distanceToStore = calculateDistance(userCoordinates.latitude, userCoordinates.longitude, storelatitude, storelongitude);
        
        // If distance to store is less than 50km
        if (distanceToStore < 50) {
            storeCloseBy = true;
            return;
        }
    }); 
    
    if (!storeCloseBy) removeStoreLocator();
};

const calculateDistance = (lat1, lon1, lat2, lon2) => {
    const earthRadius = 6371; // in kilometers

    // Convert latitude and longitude to radians
    const toRadians = (degrees) => (degrees * Math.PI) / 180;
    const phi1 = toRadians(lat1);
    const phi2 = toRadians(lat2);
    const deltaPhi = toRadians(lat2 - lat1);
    const deltaLambda = toRadians(lon2 - lon1);

    // Apply Haversine formula
    const a =
        Math.sin(deltaPhi / 2) * Math.sin(deltaPhi / 2) +
        Math.cos(phi1) *
        Math.cos(phi2) *
        Math.sin(deltaLambda / 2) *
        Math.sin(deltaLambda / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = earthRadius * c;

    return distance;
};

const removeStoreLocator = () => {
    const storeLocator = document.querySelector(FIND_IN_STORE_ACCORDION);
    storeLocator.remove();
};

const blockLocationPromt = () => {
    const browser = navigator.userAgent.toLowerCase();
    // This is only required for Safari 
    // Other browsers have the option to remember the geolocation permission. 
    if(browser.indexOf("safari") > -1) sessionStorage.setItem("geo_access", "denied");
};

// -------------------------------------
// Event Bindings
// -------------------------------------
document.addEventListener('DOMContentLoaded', () => {
    if (sessionStorage.getItem("geo_access") !== 'denied') {
        checkStoreProximity(); 
    }
});